import { formatCheckpointDistance } from '../../utils/unitUtils.js'

/**
 * Checkpoint domain model
 * Represents a race checkpoint with timing information
 */
export class Checkpoint {
  constructor(data) {
    this.id = data.id || data.checkpointId || 0
    this.number = data.number?.toString() || data.id?.toString() || '0'
    this.name = data.name || `Punkt ${this.number}`
    this.timeFromStartSeconds = data.timeFromStartSeconds || 0
    this.status = data.status || 'unknown'
    this.time = data.time ? new Date(data.time) : null
    this.distance = data.distance || 0
  }

  get formattedTime() {
    return this.timeFromStartSeconds > 0 ? 
      this._formatSecondsToTime(this.timeFromStartSeconds) : 
      '--:--'
  }

  get formattedSplitTime() {
    return this.timeFromStartSeconds > 0 ? 
      this._formatSecondsToTime(this.timeFromStartSeconds) : 
      '0:00:00'
  }

  get formattedDistance() {
    return formatCheckpointDistance(this.distance)
  }

  get checkpointTime() {
    return this.time ? this.time.toLocaleTimeString('pl-PL', {
      hour: '2-digit',
      minute: '2-digit'
    }) : '--:--'
  }

  _formatSecondsToTime(seconds) {
    if (!seconds || seconds < 0) return '0:00:00'
    
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = Math.floor(seconds % 60)
    
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    } else {
      return `${minutes}:${secs.toString().padStart(2, '0')}`
    }
  }

  static fromApiData(apiSplit, index = 0) {
    return new Checkpoint({
      id: apiSplit.checkpointId || index + 1,
      number: apiSplit.checkpointId?.toString() || index.toString(),
      name: apiSplit.name || `Punkt ${index + 1}`,
      timeFromStartSeconds: apiSplit.timeFromStartSeconds || 0,
      status: apiSplit.status || 'unknown',
      time: apiSplit.time,
      distance: apiSplit.distance || 0
    })
  }

  static calculateSplitTime(currentCheckpoint, previousCheckpoint) {
    if (!previousCheckpoint) return currentCheckpoint.formattedTime
    
    const splitSeconds = currentCheckpoint.timeFromStartSeconds - previousCheckpoint.timeFromStartSeconds
    return currentCheckpoint._formatSecondsToTime(splitSeconds)
  }
}